export const DEFAULT_DATE_PLACEHOLDER_TOKENS = {
  day: 'DD',
  month: 'MM',
  year: 'YYYY'
};
export const DATE_PLACEHOLDER_TOKENS = {
  'ar-SA': {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
  },
  'cs-CZ': {
    day: 'DD',
    month: 'MM',
    year: 'RRRR'
  },
  'da-DK': {
    day: 'DD',
    month: 'MM',
    year: 'ÅÅÅÅ'
  },
  'de-DE': {
    day: 'TT',
    month: 'MM',
    year: 'JJJJ'
  },
  'el-GR': {
    day: 'ΗΗ',
    month: 'ΜΜ',
    year: 'ΕΕΕΕ'
  },
  'en-GB': {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
  },
  'en-US': {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
  },
  'es-419': {
    day: 'DD',
    month: 'MM',
    year: 'AAAA'
  },
  'es-ES': {
    day: 'DD',
    month: 'MM',
    year: 'AAAA'
  },
  'es-US': {
    day: 'DD',
    month: 'MM',
    year: 'AAAA'
  },
  'fi-FI': {
    day: 'PP',
    month: 'KK',
    year: 'VVVV'
  },
  'fr-CA': {
    day: 'JJ',
    month: 'MM',
    year: 'AAAA'
  },
  'fr-FR': {
    day: 'JJ',
    month: 'MM',
    year: 'AAAA'
  },
  'he-IL': {
    day: 'יי',
    month: 'חח',
    year: 'שששש'
  },
  'hr-HR': {
    day: 'DD',
    month: 'MM',
    year: 'GGGG'
  },
  'it-IT': {
    day: 'GG',
    month: 'MM',
    year: 'AAAA'
  },
  'ja-JP': {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
  },
  'ko-KR': {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
  },
  'ms-MY': {
    day: 'HH',
    month: 'BB',
    year: 'TTTT'
  },
  'nb-NO': {
    day: 'DD',
    month: 'MM',
    year: 'ÅÅÅÅ'
  },
  'nl-NL': {
    day: 'DD',
    month: 'MM',
    year: 'JJJJ'
  },
  'no-NO': {
    day: 'DD',
    month: 'MM',
    year: 'ÅÅÅÅ'
  },
  'pl-PL': {
    day: 'DD',
    month: 'MM',
    year: 'RRRR'
  },
  'pt-BR': {
    day: 'DD',
    month: 'MM',
    year: 'AAAA'
  },
  'pt-PT': {
    day: 'DD',
    month: 'MM',
    year: 'AAAA'
  },
  'ru-RU': {
    day: 'ДД',
    month: 'ММ',
    year: 'ГГГГ'
  },
  'sk-SK': {
    day: 'DD',
    month: 'MM',
    year: 'RRRR'
  },
  'sl-SI': {
    day: 'DD',
    month: 'MM',
    year: 'LLLL'
  },
  'sv-SE': {
    day: 'DD',
    month: 'MM',
    year: 'ÅÅÅÅ'
  },
  'tr-TR': {
    day: 'GG',
    month: 'AA',
    year: 'YYYY'
  },
  'zh-CN': {
    day: '日',
    month: '月',
    year: '年'
  },
  'zh-Hant-TW': {
    day: '日日',
    month: '月月',
    year: '年年年年'
  }
};